var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVipCrownIcon = function SvgVipCrownIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF5E6",
    stroke: "#FAA61A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.65 12.951 5.87 5.127c.308-1.087 1.01-1.17 1.56-.184l1.517 2.715a.845.845 0 0 0 1.151.326l3.755-2.103a.846.846 0 0 1 1.152.327l2.1 3.763a.846.846 0 0 0 1.153.327l2.715-1.516c.985-.55 1.54-.11 1.232.976l-2.22 7.832c-.695 2.45-2.792 3.621-5.242 2.927L6.574 18.2a4.259 4.259 0 0 1-2.923-5.25Z"
  })));
};
export default SvgVipCrownIcon;